module.exports = __webpack_public_path__ + "static/media/white-restaurant-icon.a2ea1cee.svg";